// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-option {
  background: transparent;
  color: #6dbfdf;
  border: 1px solid #018ec6;
}

::ng-deep .modal-dialog.modal-dialog-centered {
  max-width: -moz-fit-content;
  max-width: fit-content;
}




mat-table {
  width: 100%; /* Set the width as needed, e.g., 100% */
}

.mat-column-Severity {
  width: 20px;
}


 .mat-column-Type ,.mat-column-Title {
  width: 100px;
}

.mat-column-CreatedOn , .mat-column-Phone ,.mat-column-CreatedBy{
  width: 80px;
}

.mat-column-Action {
  width: 120px;
}

  
.mat-table__wrapper {
  overflow: auto;
  padding: 1.5px;
}





  /*//End angular-editor customization*/

::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {
  top: 0.6em !important;
  bottom: 0 !important;
}



::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled){
  background-color: transparent !important;

}




::ng-deep
  .mat-form-field-flex:hover
  .mat-form-field-outline.mat-form-field-outline-thick {
  color: #05b9ff !important;
}

.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {
  color: #05b9ff !important;
}


::ng-deep .mat-form-field-wrapper{
  margin-bottom: -1.25em;
}
/*//End mat-form-field customization*/`, "",{"version":3,"sources":["webpack://./src/app/views/notifications/notifications.component.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,2BAAsB;EAAtB,sBAAsB;AACxB;;;;;AAKA;EACE,WAAW,EAAE,wCAAwC;AACvD;;AAEA;EACE,WAAW;AACb;;;CAGC;EACC,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,cAAc;EACd,cAAc;AAChB;;;;;;EAME,qCAAqC;;AAEvC;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;;;AAIA;EACE,wCAAwC;;AAE1C;;;;;AAKA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,sBAAsB;AACxB;AACA,qCAAqC","sourcesContent":[".btn-option {\r\n  background: transparent;\r\n  color: #6dbfdf;\r\n  border: 1px solid #018ec6;\r\n}\r\n\r\n::ng-deep .modal-dialog.modal-dialog-centered {\r\n  max-width: fit-content;\r\n}\r\n\r\n\r\n\r\n\r\nmat-table {\r\n  width: 100%; /* Set the width as needed, e.g., 100% */\r\n}\r\n\r\n.mat-column-Severity {\r\n  width: 20px;\r\n}\r\n\r\n\r\n .mat-column-Type ,.mat-column-Title {\r\n  width: 100px;\r\n}\r\n\r\n.mat-column-CreatedOn , .mat-column-Phone ,.mat-column-CreatedBy{\r\n  width: 80px;\r\n}\r\n\r\n.mat-column-Action {\r\n  width: 120px;\r\n}\r\n\r\n  \r\n.mat-table__wrapper {\r\n  overflow: auto;\r\n  padding: 1.5px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n  /*//End angular-editor customization*/\r\n\r\n::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {\r\n  top: 0.6em !important;\r\n  bottom: 0 !important;\r\n}\r\n\r\n\r\n\r\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled){\r\n  background-color: transparent !important;\r\n\r\n}\r\n\r\n\r\n\r\n\r\n::ng-deep\r\n  .mat-form-field-flex:hover\r\n  .mat-form-field-outline.mat-form-field-outline-thick {\r\n  color: #05b9ff !important;\r\n}\r\n\r\n.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {\r\n  color: #05b9ff !important;\r\n}\r\n\r\n\r\n::ng-deep .mat-form-field-wrapper{\r\n  margin-bottom: -1.25em;\r\n}\r\n/*//End mat-form-field customization*/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
